/*
 * File: /src/components/modals/modals-content/ModalNewCustomObject.1.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 23rd August 2018 11:48:07 am
 * Last Modified: Friday, 24th August 2018 11:46:28 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="title"></h1>
    <FormField
      class="modal-field__form modals-container__scroll-content"
      @input="collectForm"
      scope="customobjectsgroups"
      :forbiddenKeys="[]"
      :showTypeSelect="false"
      :showKey="false"
    ></FormField>
    <div class="modal-field__buttons">
      <BaseButton title="Cancel" @click.native="closeModal" :disabled="loading.save"/>
      <BaseButton title="Add" @click.native="handleSubmit" theme="primary" :loading="loading.save"/>
    </div>
  </div>
</template>

<script>
  import FormField from '@/components/forms/FormField'

  export default {
    components: {
      FormField
    },
    data () {
      return {
        title: 'Add a <strong>custom object</strong>',
        form: null,
        loading: {
          save: false
        }
      }
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      async handleSubmit () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          console.warn('Invalid form')
          return
        }

        try {
          this.loading.save = true
          await this.$store.dispatch('shopCustomobjectsgroupsList/SAVE_CUSTOM_OBJECT_GROUP', { customObjectGroup: this.form })
        } catch (e) {
          console.error(e)
        } finally {
          this.loading.save = false
        }

        this.closeModal()
      },
      collectForm (form) {
        this.form = form
      },
      handleKeyEvent (e) {
        if (e.keyCode === 13) {
          this.handleSubmit()
        }
      },
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalNewCustomObjectGroup.vue